import { Component, connect } from "macguffin"
import GameMode from "game/modes"
import GameModeGroup from "game/modes/GameModeGroup"
import Timings from "game/Timings"

import BackgroundImage from "utils/BackgroundImage"

const METER_MOVEMENT_SCALE = 1
const EARTH_OFFSET = 400
const MARS_OFFSET = 800

const EARTH_TRANSFORM_SCALE = 8
const MARS_TRANSFORM_SCALE = 20

const starsStyle = {
    backgroundPosition: "top center",
    backgroundSize: "auto",
    backgroundRepeat: "repeat"
}

@connect(state => ({
    meterPosition: state.game.meterPosition,
    jackpotDraw: state.game.jackpotDraw
}), {})
export default class MarsBackground extends Component {

    render() {
        const { props } = this
        const { meterPosition = 0, jackpotDraw, globalPaused } = props

        const animationPlayState = globalPaused ? "paused" : "running"

        const containerStyle = {
            visibility: !jackpotDraw ? "visible" : "hidden"
        }

        const planetEarthStyle = {
            backgroundPosition: "bottom left",
            transform: `translateY(${EARTH_TRANSFORM_SCALE * meterPosition}%)`,
            visibility: (meterPosition < 5) ? "visible" : "hidden",
            animationPlayState
        }

        const planetMarsStyle = {
            backgroundPosition: "center center",
            transform: `translateY(${-100 + ((meterPosition - 10) * MARS_TRANSFORM_SCALE)}%)`,
            visibility: (meterPosition > 10) ? "visible" : "hidden",
            animationPlayState
        }

        return <div key="marsTransitionContainer" className="marsTransitionContainer" style={containerStyle}>
            <BackgroundImage className="marsGreenLight" assetName="greenGalaxy" />
            <BackgroundImage className="marsOrangeLight" assetName="orangeGalaxy" />
            <BackgroundImage className="marsPinkLight" assetName="pinkGalaxy" />
            <BackgroundImage className="marsPurpleLight" assetName="purpleGalaxy" />
            <BackgroundImage className="marsStarsBackground" assetName="stars1" style={starsStyle} />
            <BackgroundImage className="marsStars2Background" assetName="stars2" style={starsStyle} />
            <BackgroundImage className="marsStars3Background" assetName="stars3" style={starsStyle} />
            <BackgroundImage className="planetEarth" assetName="planetEarth" style={planetEarthStyle}/>
            <BackgroundImage className="planetMars" assetName="planetMars" style={planetMarsStyle} />
        </div>
    }
}
